import { useQuery } from '@tanstack/react-query';
import { servicesApi } from '../api/services';

// Hook to get service categories with stats
export const useServiceCategories = () => {
  return useQuery({
    queryKey: ['service-categories'],
    queryFn: servicesApi.getServiceCategories,
    staleTime: 300000, // 5 minutes
    refetchOnWindowFocus: false
  });
};

// Hook to get services by category
export const useServicesByCategory = (categoryId, params = {}) => {
  return useQuery({
    queryKey: ['services-by-category', categoryId, params],
    queryFn: () => servicesApi.getServicesByCategory(categoryId, params),
    enabled: !!categoryId,
    staleTime: 300000, // 5 minutes
    refetchOnWindowFocus: false
  });
};

// Hook to get service details
export const useServiceDetails = (serviceId) => {
  return useQuery({
    queryKey: ['service-details', serviceId],
    queryFn: () => servicesApi.getServiceDetails(serviceId),
    enabled: !!serviceId,
    staleTime: 300000, // 5 minutes
    refetchOnWindowFocus: false
  });
};

// Hook to get service statistics
export const useServiceStatistics = (period = '30d') => {
  return useQuery({
    queryKey: ['service-statistics', period],
    queryFn: () => servicesApi.getServiceStatistics(period),
    staleTime: 300000, // 5 minutes
    refetchOnWindowFocus: false
  });
};

// Hook to get all services with filtering
export const useAllServices = (params = {}) => {
  return useQuery({
    queryKey: ['all-services', params],
    queryFn: () => servicesApi.getAllServices(params),
    staleTime: 300000, // 5 minutes
    refetchOnWindowFocus: false
  });
};

// Legacy hook for backwards compatibility
export const useServices = () => {
  const { data, isLoading, error } = useAllServices();
  
  const services = data?.services || [];
  const serviceOptions = services.map(service => ({
    value: service.id,
    label: service.service_name || `Service #${service.id}`
  }));

  return {
    services,
    serviceOptions,
    isLoading,
    error
  };
};